/*
* User change password required
*/
import * as React from 'react';
import { Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import * as AppComp from '../common/app-component-base';
import { BootstrapColXl as Col } from '../common/bootstrap/bootstrapcolxl';
import * as ReduxQueries from '../queries';
import ChangePasswordLogin from './change-password-login';

class UserChangePassword extends AppComp.AppComponentNoWrapper<AppComp.IAppComponentProps, any> {
  public constructor(props: any) {
    super(props, 'app.user-change-password.');
  }

  public render() {
    const { branding, ...rest } = this.props;

    return (
      <div>
        <Row><Col xs={12}>&nbsp;</Col></Row>
        <Row>
          <Col xs={4} xsOffset={4}>
            <Row>
              <Col xs={12}>
                <img src={branding.logo.login} />
              </Col>
            </Row>
            <Row>&nbsp;</Row>
            <Row>
              <ChangePasswordLogin />
            </Row>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state: AppComp.IAppComponentState, props): AppComp.IAppComponentProps =>
  ReduxQueries.MapQueryStateToPropsRoot(state, props, null);

export default withRouter<AppComp.IAppComponentProps>(connect(mapStateToProps, {})(UserChangePassword));



// WEBPACK FOOTER //
// ./src/user-change-password/index.tsx